module.exports = __webpack_public_path__ + "static/media/2-review-us-image.d0f56026.png";